import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../redux/store/hooks"
import {
    resetPokalApiToasterMessage,
    selectPokalApiToasterMessage
} from "../redux/PokalApiToaster"
import wait from "../util/wait"

function ToasterComponent() {
    const dispatch = useAppDispatch()

    const [shown, setShown] = useState<boolean>(false)
    const message = useAppSelector(selectPokalApiToasterMessage)

    useEffect(() => {
        if (message !== null) setShown(true)
    }, [message])

    useEffect(() => {
        if (shown) {
            wait(8000).then(() => {
                setShown(false)
                dispatch(resetPokalApiToasterMessage())
            })
        }
    }, [shown])

    return (
        <div
            style={{
                display: shown ? "block" : "none"
            }}
            className={
                "fixed top-16 right-4 bg-white bg-opacity-80 p-3 rounded shadow flex flex-col space-y-4"
            }>
            <div className={"text-rose-600 font-bold"}>
                {message?.title ?? ""}
            </div>
            <div className={"text-neutral-700"}>{message?.content ?? ""}</div>
        </div>
    )
}

export default ToasterComponent
